shadow$provide[198] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Source:{enumerable:true, get:function() {
  return Source;
}}});
var GLSL = require("../../../util/glsl.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Source extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "source", "index"];
  }
  made() {
    return this.trigger({type:"source.rebuild",});
  }
  indexShader(shader) {
    return shader.pipe(GLSL.identity("vec4"));
  }
  sourceShader(shader) {
    return shader.pipe(GLSL.identity("vec4"));
  }
  getDimensions() {
    return {items:1, width:1, height:1, depth:1,};
  }
  getActiveDimensions() {
    return this.getDimensions();
  }
  getIndexDimensions() {
    return this.getActiveDimensions();
  }
  getFutureDimensions() {
    return this.getActiveDimensions();
  }
}
Source.initClass();

};